/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusGrantPlanCreateReqVo
 */
export interface BonusGrantPlanCreateReqVo {
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    userId: number;
    /**
     * 发放来源：1-赔偿金，2-充值赠送，3-活动赠送
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    source: number;
    /**
     * 发放方式：1-一次性，2-分批
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    grantWay: number;
    /**
     * 发放总额
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    totalAmount: number;
    /**
     * 每次发放金额（分批时必填，≤总额；一次性时忽略）
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    perGrantAmount?: number;
    /**
     * 间隔类型：1-按月（每月X号），2-按天（每隔N天）；分批时必填
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    intervalType?: number;
    /**
     * 每月几号发放（intervalType=1时必填，1-31；当月无该日期按当月最后一天）
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    dayOfMonth?: number;
    /**
     * 间隔天数（intervalType=2时必填，≥1）
     * @type {number}
     * @memberof BonusGrantPlanCreateReqVo
     */
    intervalDays?: number;
    /**
     * 发放说明（附加在流水自动文案后）
     * @type {string}
     * @memberof BonusGrantPlanCreateReqVo
     */
    remark?: string;
}

/**
 * Check if a given object implements the BonusGrantPlanCreateReqVo interface.
 */
export function instanceOfBonusGrantPlanCreateReqVo(value: object): value is BonusGrantPlanCreateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('grantWay' in value) || value['grantWay'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function BonusGrantPlanCreateReqVoFromJSON(json: any): BonusGrantPlanCreateReqVo {
    return BonusGrantPlanCreateReqVoFromJSONTyped(json, false);
}

export function BonusGrantPlanCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusGrantPlanCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'source': json['source'],
        'grantWay': json['grantWay'],
        'totalAmount': json['totalAmount'],
        'perGrantAmount': json['perGrantAmount'] == null ? undefined : json['perGrantAmount'],
        'intervalType': json['intervalType'] == null ? undefined : json['intervalType'],
        'dayOfMonth': json['dayOfMonth'] == null ? undefined : json['dayOfMonth'],
        'intervalDays': json['intervalDays'] == null ? undefined : json['intervalDays'],
        'remark': json['remark'] == null ? undefined : json['remark'],
    };
}

export function BonusGrantPlanCreateReqVoToJSON(json: any): BonusGrantPlanCreateReqVo {
    return BonusGrantPlanCreateReqVoToJSONTyped(json, false);
}

export function BonusGrantPlanCreateReqVoToJSONTyped(value?: BonusGrantPlanCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'source': value['source'],
        'grantWay': value['grantWay'],
        'totalAmount': value['totalAmount'],
        'perGrantAmount': value['perGrantAmount'],
        'intervalType': value['intervalType'],
        'dayOfMonth': value['dayOfMonth'],
        'intervalDays': value['intervalDays'],
        'remark': value['remark'],
    };
}

